import type { z } from "zod";

import { zRes401 } from "./common";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zNoBody(200);
const zRes404 = Response.Schema.zNoBody(404);

const zRes = Response.Schema.zAggregated([zRes200, zRes401, zRes404]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
